"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var buttonSubmitStyles_1 = require("./buttonSubmitStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ButtonSubmit = function (_a) {
    var disabled = _a.disabled;
    var translationId = 'trans__se__instore_payment__submit_CTA';
    var styles = buttonSubmitStyles_1.default();
    return (<core_1.Box className={styles.submitButtonContainer}>
      <core_1.Button type="submit" disabled={disabled} className={styles.submitButton} classes={{ contained: styles.btnContained, containedPrimary: styles.newContainedPrimary }} variant="contained" color="primary" data-test="button:instorepayment_form:submit">
        <Translation_1.default id={translationId}/>
      </core_1.Button>
    </core_1.Box>);
};
exports.default = ButtonSubmit;
